// src/components/button/ChartTypeSelector.tsx

import {
  BarChartTwoTone,
  ShowChartTwoTone,
  TimelineTwoTone,
} from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { ComponentProps } from 'react'

const data = [
  { icon: BarChartTwoTone, title: 'Säulendiagramm', type: 'ColumnChart' },
  { icon: ShowChartTwoTone, title: 'Bereichsdiagramm', type: 'AreaChart' },
  { icon: TimelineTwoTone, title: 'Liniendiagramm', type: 'LineChart' },
]

type Props = ComponentProps<typeof ToggleButtonGroup>

export const ChartTypeSelector = ({ ...rest }: Props) => (
  <ToggleButtonGroup exclusive {...rest}>
    {data.map(item => (
      <ToggleButton key={item.title} value={item.type}>
        <Tooltip title={item.title}>
          <item.icon />
        </Tooltip>
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
)
